<script> 
import forminput from "@/router/views/formcomponet/forminput.vue"; 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import opersonel from "@/models/opersonel"; 
import useVuelidate from "@vuelidate/core";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, opersonel],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
      KaydetButton: false,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE
    };
  },
  components: {
    forminput,treeselect
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
    "FormData.Ilid"(){
      this.IlceGet()
    }
  },
  methods: {
    IlceGet(){ 
      const item = this.FormDataType.Ilid.ComboDataArray.find(item => item.id === this.FormData.Ilid);
      this.ActionsFilterGet({ Service: "oililce", FullData: true, Filter: "&Ustid=" + item.kod }).then((res) => {
        this.FormDataType.Ilceid.ComboDataArray = res.Data.map(item => ({
          id: item.Id,
          label: item.Value
        }));
      });
    },
     onSubmit() {
      this.v$.FormData.$touch();
      if (!this.v$.FormData.$invalid) {
        this.KaydetButton = true 
        if (this.AddEdit == "Add") {
        
          this.Post2("opersonel", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.opersonelData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
            this.KaydetButton = false
           
          });
        
        } else { 
          this.Update("opersonel", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.opersonelData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
              this.KaydetButton = false
            }
          });
           
        }
      }
    },
    Get() {
      this.KaydetButton = false
    },
  },
};
</script>
<template>
  <b-modal
    v-model="ModalOpen"
    id="opersonel"
    size="lg"
    :title="
      this.AddEdit == 'Edit'
        ? 'Kayıt Düzenle'
        : 'Yeni Kayıt Ekle'
    "
    title-class="font-18"
    hide-footer
  >
    <Form @submit.prevent="onSubmit" v-if="FormData">  
    
<div class="row">
      <forminput class="col-lg-6"
        :FormDataType="FormDataType.Adsoyad"
        :Value="FormData.Adsoyad"
        :v="v$.FormData.Adsoyad"
        @input="FormData.Adsoyad = $event.target.value"
      />
      <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Birimid.FieldTitle"
        :key="FormData.Birimid">
        <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray" placeholder="Seçiniz..."
          v-model="FormData.Birimid" />
        <treeselect-value :value="FormData.Birimid" />
      </b-form-group>

      <forminput class="col-lg-6"
        :FormDataType="FormDataType.Eposta"
        :Value="FormData.Eposta"
        :v="v$.FormData.Eposta"
        @input="FormData.Eposta = $event.target.value"
      />
      <forminput class="col-lg-6"
        :FormDataType="FormDataType.Telefon"
        :Value="FormData.Telefon"
        :v="v$.FormData.Telefon"
        @input="FormData.Telefon = $event.target.value"
      />
      <forminput class="col-lg-6"
        :FormDataType="FormDataType.Dahili"
        :Value="FormData.Dahili"
        :v="v$.FormData.Dahili"
        @input="FormData.Dahili = $event.target.value"
      />
      <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Personeltipid.FieldTitle"
        :key="FormData.Personeltipid">
        <treeselect :multiple="false" :options="FormDataType.Personeltipid.ComboDataArray" placeholder="Seçiniz..."
          v-model="FormData.Personeltipid" />
        <treeselect-value :value="FormData.Personeltipid" />
      </b-form-group>


      <forminput class="col-lg-6"
        :FormDataType="FormDataType.Tckimlikno"
        :Value="FormData.Tckimlikno"
        :v="v$.FormData.Tckimlikno"
        @input="FormData.Tckimlikno = $event.target.value"
      />


      <b-form-group class="col-lg-6"  v-if="APPLICATION_TYPE == 2" label-for="text" :label="FormDataType.Ilid.FieldTitle"
        :key="FormData.Ilid">
        <treeselect :multiple="false" :options="FormDataType.Ilid.ComboDataArray" placeholder="Seçiniz..."
          v-model="FormData.Ilid" />
        <treeselect-value :value="FormData.Ilid" />
      </b-form-group>

      <b-form-group class="col-lg-6"  v-if="APPLICATION_TYPE == 2" label-for="text" :label="FormDataType.Ilceid.FieldTitle"
        :key="FormData.Ilceid">
        <treeselect :multiple="false" :options="FormDataType.Ilceid.ComboDataArray" placeholder="Seçiniz..."
          v-model="FormData.Ilceid" />
        <treeselect-value :value="FormData.Ilceid" />
      </b-form-group>
      
      <forminput class="col-lg-6" v-if="APPLICATION_TYPE == 2"
        :FormDataType="FormDataType.Adres"
        :Value="FormData.Adres"
        :v="v$.FormData.Adres"
        @input="FormData.Adres = $event.target.value"
      />
      <forminput class="col-lg-6" v-if="APPLICATION_TYPE == 2"
        :FormDataType="FormDataType.Mahalle" 
        :Value="FormData.Mahalle"
        :v="v$.FormData.Mahalle"
        @input="FormData.Mahalle = $event.target.value"
      />
      
    </div>

      <button class="btn btn-primary" type="submit" :disabled="KaydetButton">
        {{ KaydetButton ? 'Kaydediliyor' : 'Kaydet'}}
      </button>
    </Form>
  </b-modal>
</template>
